import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { getDataTestIdProps } from 'common/utils';
import React from 'react';
import { attributeTextStyles } from './AttributeItemTextStyles';
import ItemLabel from './ItemLabel';

const ItemText: React.FC<{
  label: string;
  value: string | string[];
  noWrap: boolean;
  highligted?: boolean;
  variant?: 'small' | 'large' | 'verysmall';
  textAlign?: 'left' | 'right';
  priorityItemTextDataTestId?: string;
  labelColor?: string
  containerClassName?: string
}> = ({
  label,
  value,
  noWrap,
  highligted,
  variant = 'small',
  textAlign = 'left',
  priorityItemTextDataTestId,
  labelColor,
  containerClassName
}) => {
  const classes = attributeTextStyles();
  return (
    <Box
      display="flex"
      width={1}
      className={containerClassName}
      justifyContent={textAlign === 'right' ? 'flex-end' : 'normal'}
      {...(label === 'Priority' &&
        getDataTestIdProps(priorityItemTextDataTestId ?? ''))}
    >
      <ItemLabel text={label} variant={variant} 
        labelColor={labelColor}
      />
      {Array.isArray(value) ? (
        <Box width={1}>
          {value.map((text, index) => (
            <Typography
              noWrap={noWrap}
              color={highligted ? 'primary' : undefined}
              className={classes[variant]}
              key={index}
            >
              {text}
            </Typography>
          ))}
        </Box>
      ) : (
        <Typography
          noWrap={noWrap}
          className={classes[variant]}
          color={highligted ? 'primary' : undefined}
        >
          {value}
        </Typography>
      )}
    </Box>
  );
};

export default React.memo(ItemText);
